// eslint-disable-next-line import/prefer-default-export
export const TYPE1 = 'TYPE1';
